import HubertInput from 'components/HubertUI/HubertInput';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';

interface Props extends TRuleEditorCommonProps {
  value: string;
  ruleIdx: number;
  onCommit: (name: string) => void;
}

const RuleNameInput = ({ value, ruleIdx, isReadOnly, onCommit }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <HubertInput
      type="text"
      placeholder={t('question.rules.namePlaceholder', { index: ruleIdx })}
      defaultValue={value}
      disabled={isReadOnly}
      onBlur={(e) => {
        if (e.target.value === value) return;
        onCommit(e.target.value);
      }}
    />
  );
};

export default RuleNameInput;
